export default __webpack_public_path__ + "static/media/bitstop-app-apple-store.8a6141f5.svg";